import * as React from 'react'
import Svg, { SvgProps, Path } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconCheckmark = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconCheckmark.dimensions.width} ${IconCheckmark.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill={color || Color.premiumBlack}
        d="m7.954 14.681-.572-.484-.003.003.575.481Zm-.002.002.573.485-.573-.485Zm-.646 0-.572.485.572-.485ZM.884 7.093l-.573.484.573-.484Zm0-.764L.31 5.845l.573.484Zm.646 0 .572-.484-.572.484Zm6.1 7.21-.573.484.572.676.573-.676-.573-.485ZM17.97 1.316l.573.484-.573-.484Zm.646 0 .573-.484-.573.484Zm0 .763.573.485-.573-.485ZM7.38 14.2v-.001l1.146.969.004-.005-1.15-.963Zm0-.001a.33.33 0 0 1 .25-.108.33.33 0 0 1 .25.108l-1.145.969a1.158 1.158 0 0 0 1.79 0l-1.144-.97Zm.5 0-6.423-7.59-1.145.968 6.423 7.59 1.145-.968Zm-6.423-7.59c.04.046.044.085.044.102a.161.161 0 0 1-.044.103l-1.145-.97a1.36 1.36 0 0 0 0 1.733l1.145-.969Zm0 .205a.33.33 0 0 1-.25.107.33.33 0 0 1-.249-.107l1.145-.97a1.158 1.158 0 0 0-1.79 0l1.144.97Zm-.499 0 6.1 7.209 1.145-.97-6.1-7.208-1.145.969Zm7.245 7.209L18.542 1.8 17.399.833 7.057 13.053l1.145.97ZM18.542 1.8a.33.33 0 0 1-.249.108.33.33 0 0 1-.25-.108L19.19.833a1.158 1.158 0 0 0-1.791 0l1.145.968Zm-.498 0A.161.161 0 0 1 18 1.7c0-.017.005-.057.044-.103l1.145.969a1.36 1.36 0 0 0 0-1.732l-1.145.968Zm0-.205-10.662 12.6 1.145.97L19.189 2.564l-1.145-.97Z"
      />
    </Svg>
  )
}

IconCheckmark.dimensions = {
  width: 20,
  height: 16,
}

export default IconCheckmark
